import { Routes} from '@angular/router';
import { authGuard, guestGuard } from './guards/auth/auth.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LayoutComponent } from './components/layout/layout.component';



// export const routes: Routes = [
//     // {path: '', redirectTo: 'login',pathMatch: 'full'},
//     // {path: 'login',component: LoginComponent},
//     {path: '', loadComponent: ()=> import('./components/login/login.component').then((x)=>x.LoginComponent)},
//     // {path: '', loadComponent: ()=> import('./components/dashboard/dashboard.component').then((x)=>x.DashboardComponent),canActivate: [authGuard]   },
//      {
//     path: '', 
//     component: LayoutComponent,          // contains sidebar + navbar
//     canActivate: [authGuard],
//     children: [
//     {path: 'dashboard', component: DashboardComponent },
//     {path: 'backlogs', loadComponent: ()=>import('./components/backlog/backlog.component').then((x)=>x.BacklogComponent), canActivate: [authGuard]},
//     {path: 'search', loadComponent: ()=>import('./components/studentdashboard/studentdashboard.component').then((x)=>x.StudentdashboardComponent), canActivate: [authGuard]},
//     //add all your internal pages here…
//     // {path: 'backlogs', loadComponent: ()=>import('./components/backlog/backlog.component').then((x)=>x.BacklogComponent), canActivate: [authGuard]},
//     {path: 'stform', loadComponent: ()=>import('./components/stform/stform.component').then((x)=>x.StformComponent),canActivate: [authGuard]},
//     {path: 'cgpa/rfinal', loadComponent: ()=>import('./components/rfinalyear/rfinalyear.component').then((x)=>x.RfinalyearComponent),canActivate: [authGuard]},
//     {path: 'cgpa/rthird', loadComponent: ()=>import('./components/rthirdyear/rthirdyear.component').then((x)=>x.RthirdyearComponent),canActivate: [authGuard]},
//     {path: 'cgpa/rsecond', loadComponent: ()=>import('./components/rsecondyear/rsecondyear.component').then((x)=>x.RsecondyearComponent),canActivate: [authGuard]},
//     {path: 'cgpa/rfirst', loadComponent: ()=>import('./components/rfirstyear/rfirstyear.component').then((x)=>x.RfirstyearComponent),canActivate: [authGuard]},
//     {path: 'student/login', loadComponent: ()=>import('./components/student-login/student-login.component').then((x)=> x.StudentLoginComponent)},
//     {path: 'essl/employee', loadComponent: ()=>import('./components/essl/essl-attendance/essl-attendance.component').then((x)=>x.EsslAttendanceComponent),canActivate: [authGuard]},
//     {path: 'essl/report', loadComponent: ()=>import('./components/essl/essl-report/essl-report.component').then((x)=>x.EsslReportComponent),canActivate: [authGuard]},
//     {path: 'essl/lates', loadComponent: ()=>import('./components/essl/essl-lates/essl-lates.component').then((x)=>x.EsslLatesComponent),canActivate: [authGuard]},
//     {path: 'essl/staffparticulars', loadComponent: ()=>import('./components/essl/staff-particulars/staff-particulars.component').then((x)=>x.StaffParticularsComponent),canActivate: [authGuard]},
//     {path: 'strength', loadComponent: ()=>import('./components/students/strength-particulars/strength-particulars.component').then((x)=>x.StrengthParticularsComponent),canActivate: [authGuard]},
//     {path: 'user/registration', loadComponent: ()=>import('./components/staff/staff-login/staff-login.component').then((x)=>x.StaffLoginComponent)},
//     {path: 'principal/dashboard', loadComponent: ()=>import('./components/principal/tot-dashboard/tot-dashboard.component').then((x)=>x.TotDashboardComponent)},
//     {path: 'principal/department/:dept', loadComponent: ()=>import('./components/principal/principal-dashboard/principal-dashboard.component').then((x)=>x.PrincipalDashboardComponent),canActivate: [authGuard]},
//     {path: 'mentor/students', loadComponent: ()=>import('./components/staff/mentor-students/mentor-students.component').then((x)=>x.MentorStudentsComponent),canActivate: [authGuard]},
//     {path: 'mentor/students/cgpa', loadComponent: ()=>import('./components/staff/student-cgpa/student-cgpa.component').then((x)=>x.StudentCgpaComponent),canActivate: [authGuard]},
//     {path: 'mentor/students/backlogs', loadComponent: ()=>import('./components/staff/student-backlogs/student-backlogs.component').then((x)=>x.StudentBacklogsComponent),canActivate: [authGuard]},
//     {path: 'mentor/students/attendance', loadComponent: ()=>import('./components/staff/mentee-attendance/mentee-attendance.component').then((x)=>x.MenteeAttendanceComponent),canActivate: [authGuard]},
//     {path: 'subject/registration', loadComponent: ()=>import('./components/subjects/subject-creation/subject-creation.component').then((x)=>x.SubjectCreationComponent),canActivate: [authGuard]},
//     {path: 'admin/inst', loadComponent: ()=>import('./components/admin/intitute-creation/intitute-creation.component').then((x)=>x.IntituteCreationComponent),canActivate: [authGuard]},
//     {path: 'admin/department', loadComponent: ()=>import('./components/admin/department-creation/department-creation.component').then((x)=>x.DepartmentCreationComponent),canActivate: [authGuard]},
//     {path: 'admin/branch', loadComponent: ()=>import('./components/admin/branch-creation/branch-creation.component').then((x)=>x.BranchCreationComponent),canActivate: [authGuard]},
//     {path: 'admin/class', loadComponent: ()=>import('./components/admin/class-creation/class-creation.component').then((x)=>x.ClassCreationComponent),canActivate: [authGuard]},
//     {path: 'subject/list', loadComponent: ()=>import('./components/subjects/subject-list/subject-list.component').then((x)=>x.SubjectListComponent),canActivate: [authGuard]},
//     {path: 'subjectoe/registration',loadComponent: ()=>import('./components/subjects/subject-oe/subject-oe.component').then((x)=>x.SubjectOeComponent),canActivate: [authGuard]},
//     {path: 'subject/subassnbranch', loadComponent: ()=>import('./components/subjects/subject-offer-branch/subject-offer-branch.component').then((x)=>x.SubjectOfferBranchComponent),canActivate: [authGuard]},
//     {path: 'classcoordinator/students', loadComponent: ()=>import('./components/staff/class-coordinator/class-coordinator.component').then((x)=>x.ClassCoordinatorComponent),canActivate: [authGuard]},
//     {path: 'classcoordinator/students/cgpa', loadComponent: ()=>import('./components/staff/class-coordinator-cgpa/class-coordinator-cgpa.component').then((x)=>x.ClassCoordinatorCgpaComponent),canActivate: [authGuard]},
//     {path: 'classcoordinator/students/backlogs', loadComponent: ()=>import('./components/staff/class-coordinator-backlogs/class-coordinator-backlogs.component').then((x)=>x.ClassCoordinatorBacklogsComponent),canActivate: [authGuard]},
//     {path: 'classcoordinator/students/attendance', loadComponent: ()=>import('./components/staff/class-coordinator-attendance/class-coordinator-attendance.component').then((x)=>x.ClassCoordinatorAttendanceComponent),canActivate: [authGuard]},
//     {path: 'user/change-password', loadComponent: ()=>import('./components/staff/change-password/change-password.component').then((x)=>x.ChangePasswordComponent),canActivate: [authGuard]},
//     {path: 'faulty/subjects', loadComponent: ()=>import('./components/staff/faculty-subjects/faculty-subjects.component').then((x)=>x.FacultySubjectsComponent),canActivate: [authGuard]},
//     {path: 'faculty/oesubjects',loadComponent: ()=>import('./components/staff/oesubjects/oesubjects/oesubjects.component').then((x)=>x.OesubjectsComponent),canActivate: [authGuard]},
//     {path: 'subject/timetable', loadComponent: ()=>import('./components/subjects/timetable-registration/timetable-registration.component').then((x)=>x.TimetableRegistrationComponent),canActivate: [authGuard]},
//     {path: 'faculty/timetable', loadComponent: ()=>import('./components/staff/individual-timetable/individual-timetable.component').then((x)=>x.IndividualTimetableComponent),canActivate: [authGuard]},
// ]
// },
// {path: '', redirectTo: 'login', pathMatch: 'full' },
// {path: '**', redirectTo: 'login' }
// ];

// export const routes: Routes = [
//   { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

//   // 🔐 Protected routes
//   { path: 'dashboard', loadComponent: () => import('./components/dashboard/dashboard.component').then(x => x.DashboardComponent)  },
//   { path: 'stform', loadComponent: () => import('./components/stform/stform.component').then(x => x.StformComponent)},

//   // 🔓 Public routes
//   { path: 'login', loadComponent: () => import('./components/login/login.component').then(x => x.LoginComponent) },
//   { path: 'backlogs', loadComponent: () => import('./components/backlog/backlog.component').then(x => x.BacklogComponent) },
//   { path: 'search', loadComponent: () => import('./components/studentdashboard/studentdashboard.component').then(x => x.StudentdashboardComponent) },

//   // 🔁 Fallback route
//   { path: '**', redirectTo: 'login' },
// ];


export const routes: Routes = [

  // redirect first
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // login
  { 
    path: 'login', 
    loadComponent: () => import('./components/login/login.component')
      .then(x => x.LoginComponent),
      canActivate: [guestGuard],
      data: { title: 'Login', breadcrumb: 'Login'} 
  },

  // main layout
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent,
        data: {title: 'Dashboard', breadcrumb: 'Dashboard'}
       },
      { path: 'backlogs', loadComponent: () => import('./components/backlog/backlog.component').then(x => x.BacklogComponent),
        data: {title: 'Backlogs', breadcrumb: 'Backlogs'}
       },
      { path: 'search', loadComponent: () => import('./components/studentdashboard/studentdashboard.component').then(x => x.StudentdashboardComponent),
        data: {title: 'Search', breadcrumb: 'Search'}
       },

      { path: 'stform', loadComponent: () => import('./components/stform/stform.component').then(x => x.StformComponent),
        data: {title: 'StudentForm', breadcrumb: 'StudentForm'}
       },

      { path: 'cgpa/rfinal', loadComponent: () => import('./components/rfinalyear/rfinalyear.component').then(x => x.RfinalyearComponent),
        data: {title: 'Final Year CGPA', breadcrumb: 'Final Year'}
       },
      { path: 'cgpa/rthird', loadComponent: () => import('./components/rthirdyear/rthirdyear.component').then(x => x.RthirdyearComponent),
        data: {title: 'Third Year CGPA', breadcrumb: 'Third Year'}
       },
      { path: 'cgpa/rsecond', loadComponent: () => import('./components/rsecondyear/rsecondyear.component').then(x => x.RsecondyearComponent),
        data: {title: 'Second Year CGPA', breadcrumb: 'Second Year'}
       },
      { path: 'cgpa/rfirst', loadComponent: () => import('./components/rfirstyear/rfirstyear.component').then(x => x.RfirstyearComponent),
        data: {title: 'First Year CGPA', breadcrumb: 'First Year'}
       },
      { path: 'essl/employee', loadComponent: () => import('./components/essl/essl-attendance/essl-attendance.component').then(x => x.EsslAttendanceComponent),
        data: {title: 'Employee Attendance', breadcrumb: 'Employee Attendance'}
      },
      { path: 'essl/report', loadComponent: () => import('./components/essl/essl-report/essl-report.component').then(x => x.EsslReportComponent),
        data: {title: 'Leaves Report', breadcrumb: 'Leave Report'}
       },
      { path: 'essl/lates', loadComponent: () => import('./components/essl/essl-lates/essl-lates.component').then(x => x.EsslLatesComponent),
        data: {title: 'Late Coming Report', breadcrumb: 'Lates Report'}
       },
      { path: 'essl/staffparticulars', loadComponent: () => import('./components/essl/staff-particulars/staff-particulars.component').then(x => x.StaffParticularsComponent),
        data: {title: 'Staff Particulars', breadcrumb: 'Staff Particulars'}
       },

      { path: 'strength', loadComponent: () => import('./components/students/strength-particulars/strength-particulars.component').then(x => x.StrengthParticularsComponent),
        data: {title: 'Strength Particulars', breadcrumb: 'Strength'}
       },

      { path: 'user/registration', loadComponent: () => import('./components/staff/staff-login/staff-login.component').then(x => x.StaffLoginComponent),
        data: {title: 'User Registration', breadcrumb: 'User Registration'}
       },

      { path: 'principal/dashboard', loadComponent: () => import('./components/principal/tot-dashboard/tot-dashboard.component').then(x => x.TotDashboardComponent),
        data: { title: 'Principal Dashboard', breadcrumb: 'Dashboard' }
       },
      { path: 'principal/department/:dept/:ayId', loadComponent: () => import('./components/principal/principal-dashboard/principal-dashboard.component').then(x => x.PrincipalDashboardComponent),
        data: { title: 'Department Dashboard', breadcrumb: 'Department' }
       },
      { path: 'principal/department/:dept', loadComponent: () => import('./components/principal/principal-dashboard/principal-dashboard.component').then(x => x.PrincipalDashboardComponent),
        data: { title: 'Department Dashboard', breadcrumb: 'Department' }
       },

      { path: 'mentor/students', loadComponent: () => import('./components/staff/mentor-students/mentor-students.component').then(x => x.MentorStudentsComponent),
        data: { title: 'Mentor Students', breadcrumb: 'Students' }
       },
      { path: 'mentor/students/cgpa', loadComponent: () => import('./components/staff/student-cgpa/student-cgpa.component').then(x => x.StudentCgpaComponent),
        data: { title: 'Mentee CGPA', breadcrumb: 'CGPA' }
       },
      { path: 'mentor/students/backlogs', loadComponent: () => import('./components/staff/student-backlogs/student-backlogs.component').then(x => x.StudentBacklogsComponent),
        data: { title: 'Mentee Backlogs', breadcrumb: 'Backlogs' }
       },
      { path: 'mentor/students/attendance', loadComponent: () => import('./components/staff/mentee-attendance/mentee-attendance.component').then(x => x.MenteeAttendanceComponent),
        data: { title: 'Mentee Attendance', breadcrumb: 'Attendance' }
       },

      { path: 'subject/registration', loadComponent: () => import('./components/subjects/subject-creation/subject-creation.component').then(x => x.SubjectCreationComponent),
        data: { title: 'Subject Registration', breadcrumb: 'Subject Registration' }
       },

      { path: 'admin/inst', loadComponent: () => import('./components/admin/intitute-creation/intitute-creation.component').then(x => x.IntituteCreationComponent),
        data: { title: 'Institute Creation', breadcrumb: 'Institute' }
       },
      { path: 'admin/department', loadComponent: () => import('./components/admin/department-creation/department-creation.component').then(x => x.DepartmentCreationComponent),
        data: { title: 'Department Creation', breadcrumb: 'Department' }
       },
      { path: 'admin/branch', loadComponent: () => import('./components/admin/branch-creation/branch-creation.component').then(x => x.BranchCreationComponent),
        data: { title: 'Branch Creation', breadcrumb: 'Branch' }
       },
      { path: 'admin/class', loadComponent: () => import('./components/admin/class-creation/class-creation.component').then(x => x.ClassCreationComponent),
        data: { title: 'Class Creation', breadcrumb: 'Class' }
       },

      { path: 'subject/list', loadComponent: () => import('./components/subjects/subject-list/subject-list.component').then(x => x.SubjectListComponent),
        data: { title: 'Subject List', breadcrumb: 'Subject List' }
       },
      { path: 'subjectoe/registration', loadComponent: () => import('./components/subjects/subject-oe/subject-oe.component').then(x => x.SubjectOeComponent),
        data: { title: 'OE Subject Registration', breadcrumb: 'OE Registration' }
       },
      { path: 'subject/subassnbranch', loadComponent: () => import('./components/subjects/subject-offer-branch/subject-offer-branch.component').then(x => x.SubjectOfferBranchComponent),
        data: { title: 'Subject Offer Branch', breadcrumb: 'Offer Branch' }
       },

      { path: 'classcoordinator/students', loadComponent: () => import('./components/staff/class-coordinator/class-coordinator.component').then(x => x.ClassCoordinatorComponent),
        data: { title: 'Class Coordinator Students', breadcrumb: 'Students' }
       },
      { path: 'classcoordinator/students/cgpa', loadComponent: () => import('./components/staff/class-coordinator-cgpa/class-coordinator-cgpa.component').then(x => x.ClassCoordinatorCgpaComponent),
        data: { title: 'Coordinator CGPA', breadcrumb: 'CGPA' }
       },
      { path: 'classcoordinator/students/backlogs', loadComponent: () => import('./components/staff/class-coordinator-backlogs/class-coordinator-backlogs.component').then(x => x.ClassCoordinatorBacklogsComponent),
        data: { title: 'Coordinator Backlogs', breadcrumb: 'Backlogs' }
       },
      { path: 'classcoordinator/students/attendance', loadComponent: () => import('./components/staff/class-coordinator-attendance/class-coordinator-attendance.component').then(x => x.ClassCoordinatorAttendanceComponent),
        data: { title: 'Coordinator Attendance', breadcrumb: 'Attendance' }
       },

      { path: 'user/change-password', loadComponent: () => import('./components/staff/change-password/change-password.component').then(x => x.ChangePasswordComponent),
        data: { title: 'Change Password', breadcrumb: 'Change Password' }
       },

      { path: 'faculty/subjects', loadComponent: () => import('./components/staff/faculty-subjects/faculty-subjects.component').then(x => x.FacultySubjectsComponent),
        data: { title: 'Faculty Subjects', breadcrumb: 'Subjects' }
       },
      { path: 'faculty/oesubjects', loadComponent: () => import('./components/staff/oesubjects/oesubjects/oesubjects.component').then(x => x.OesubjectsComponent),
        data: { title: 'Faculty OE Subjects', breadcrumb: 'OE Subjects' }
       },

      { path: 'subject/timetable', loadComponent: () => import('./components/subjects/timetable-registration/timetable-registration.component').then(x => x.TimetableRegistrationComponent),
        data: { title: 'Timetable Registration', breadcrumb: 'Timetable' }
       },
       {
        path: 'faculty/timetable',
        loadComponent: () => import('./components/staff/individual-timetable/individual-timetable.component').then(x => x.IndividualTimetableComponent),
        data: { title: 'Faculty Timetable', breadcrumb: 'Timetable' }
       },
       {
        path: 'myattendance',
        loadComponent: () => import('./components/dashboards/cadashboard/individual-attendance/individual-attendance.component').then(x => x.IndividualAttendanceComponent),
        data: { title: 'My Attendance', breadcrumb: 'My Attendance' }
       },
       {
        path: 'dept/circulars',
        loadComponent: () => import('./components/hoddashboard/dept-circulars/dept-circulars.component')
          .then(x => x.DeptCircularsComponent),
        data: { title: 'Department Circulars', breadcrumb: 'Circulars' }
       },
       {
        path: 'minutes/acouncil',
        loadComponent: ()=> import('./components/hoddashboard/academic-council-minutes/academic-council-minutes.component')
        .then(x=>x.AcademicCouncilMinutesComponent),
        data: {title: 'Academic Council Minutes', breadcrumb: 'Minutes'}
       },
       {
        path: 'minutes/iqac',
        loadComponent: ()=> import('./components/hoddashboard/iqac-minutes/iqac-minutes.component')
        .then(x=>x.IqacMinutesComponent),
        data: {title: 'IQAC Minutes', breadcrumb: 'Minutes'}
       },
       {
        path: 'minutes/bog',
        loadComponent: ()=>import('./components/hoddashboard/bog-minutes/bog-minutes.component')
        .then(x=>x.BogMinutesComponent),
        data: {title: 'BOG Minutes', breadcrumb: 'Minutes'}
       },
       {
        path: 'minutes/bos',
        loadComponent: ()=>import('./components/hoddashboard/bos-minutes/bos-minutes.component')
        .then(x=>x.BosMinutesComponent),
        data: {title: 'BOS Minutes', breadcrumb: 'Minutes'}
       },
       {
        path: 'faculty/dashboard',
        loadComponent: ()=>import('./components/facultydashboard/faculty-dashboard/faculty-dashboard.component')
        .then(x=>x.FacultyDashboardComponent),
        data: {title: 'Faculty Dashboard',breadcrumb: 'Dashboard'}
       },
       {
        path: 'faculty/menteeform',
        loadComponent: ()=>import('./components/facultydashboard/mentor-mentee-form/mentor-mentee-form.component')
        .then(x=>x.MentorMenteeFormComponent),
        data: {title: 'Mentee Form', breadcrumb: 'Mentee Form'}
       },
       {
        path: 'mentormentee/reports',
        loadComponent: ()=>import('./components/hoddashboard/mentor-mentee-report/mentor-mentee-report.component')
        .then(x=>x.MentorMenteeReportComponent),
        data: {title: 'Mentor Mentee Reports', breadcrumb: 'Reports'}
       },
       {
        path: 'mentor/report',
        loadComponent: ()=>import('./components/staff/mentor-form-report/mentor-form-report.component')
        .then(x=>x.MentorFormReportComponent),
        data: {title: 'Mentor Report', breadcrumb: 'Mentor'}
       },
       {
        path: 'coe/dashboard',
        loadComponent: ()=>import('./components/coedashboard/coe-dashboard-layout/coe-dashboard-layout.component')
        .then(x=>x.CoeDashboardLayoutComponent),
        data: {title: 'COE Dashboard', breadcrumb: 'Dashboard'}
       },
       {
        path: 'cc/dashboard',
        loadComponent: ()=>import('./components/cc-dashboard/computer-centre-dashboard/computer-centre-dashboard.component')
        .then(x=>x.ComputerCentreDashboardComponent),
        data: {title: 'CC Dashboard', breadcrumb: 'Dashboard'}
       },
       {
        path: 'cc/rooms/details',
        loadComponent: ()=>import('./components/cc-dashboard/rooms-details/rooms-details.component')
        .then(x=>x.RoomsDetailsComponent),
        data: {title: 'Block Rooms Details', breadcrumb: 'Forms'}
       },
       {
        path: 'lab/assign-staff',
        loadComponent: ()=>import('./components/dashboards/deodashboard/lab-assign-staff/lab-assign-staff.component')
        .then(x=>x.LabAssignStaffComponent),
        data: {title: 'Lab Assign Staff', breadcrumb: 'Forms'}
       },
      //  {
      //   path: 'lab/assign-staff/list',
      //   loadComponent: ()=>import('./components/dashboards/deodashboard/lab-assign-staff-list/lab-assign-staff-list.component')
      //   .then(x=>x.LabAssignStaffListComponent),
      //   data: {title: 'lab-assign-staff', breadcrumb: 'lab-assign-staff-list'}
      //  },
       {
        path: 'computerassistant/dashboard',
        loadComponent: ()=>import('./components/dashboards/cadashboard/computer-assistant-layout/computer-assistant-layout.component')
        .then(x=>x.ComputerAssistantLayoutComponent),
        data: {title: 'Computer-Assistant-Dashboard',breadcrumb: 'Dashboard'}
       },
       {
        path: 'blocks/rooms/details',
        loadComponent: ()=>import('./components/dashboards/deodashboard/room-details-form/room-details-form.component')
        .then(x=>x.RoomDetailsFormComponent),
        data: {title: 'Block Rooms Creation Form',breadcrumb: 'Forms'}
       },
       {
        path: 'ca/lab/excel/upload',
        loadComponent: ()=>import('./components/dashboards/cadashboard/labsystems-excel-upload/labsystems-excel-upload.component')
        .then(x=>x.LabsystemsExcelUploadComponent),
        data: {title: 'Lab Excel Upload', breadcrumb: 'Forms'}
       },
        {
        path: 'myattendance',
        loadComponent: () => import('./components/dashboards/cadashboard/inidvidual-attendance/inidvidual-attendance.component')
        .then(x => x.InidvidualAttendanceComponent),
        data: { title: 'My Attendance', breadcrumb: 'My Attendance' }
       },
       {
        path: 'individual/lates/report',
        loadComponent: () => import('./components/essl/total-individual-lates-report/total-individual-lates-report.component')
        .then(x => x.TotalIndividualLatesReportComponent),
        data: { title: 'My Lates Report', breadcrumb: 'My Lates' }
       },
       {
        path: 'employee',
        loadChildren: () => import('./components/employees/employee.routes')
        .then(m => m.employeeRoutes)
       },
       {
        path: 'employees',
        loadChildren: () => import('./components/employees/employee.routes')
        .then(m => m.employeesListRoutes)
       },
       {
        path: 'signals',
        loadComponent: () => import('./components/signals-practice/parent/parent.component')
        .then(m => m.ParentComponent),
        data: {title: 'Signals Practice', breadcrumb: 'Signals Practice'}
       },
       {
        path: 'employee/profile',
        loadComponent: () => import('./components/staff/staff-profile/staff-profile.component')
        .then(m => m.StaffProfileComponent),
        data: {title: 'Employee Profile', breadcrumb: 'Employee Profile'},
        children: [
          {
            path: '',
            redirectTo: 'basic',
            pathMatch: 'full',
          },
          {
            path: 'basic',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-basic-details/my-basic-details.component')
            .then(m=> m.MyBasicDetailsComponent)
          },
          {
            path: 'skills',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-computer-skills/my-computer-skills.component')
            .then(m=>m.MyComputerSkillsComponent)
          },
          {
            path: 'awards',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-awards/my-awards.component')
            .then(m => m.MyAwardsComponent)
          },
          {
            path: 'address',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-address/my-address.component')
            .then(m => m.MyAddressComponent)
          },
          {
            path: 'subjects-taught',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-subject-taughts/my-subject-taughts.component')
            .then(m => m.MySubjectTaughtsComponent)
          },
          {
            path: 'qualifications',
            loadComponent: ()=> import('./components/staff/Profileeditcomponents/my-qualification/my-qualification.component')
            .then(m=>m.MyQualificationComponent)
          },
          {
            path: 'relationships',
            loadComponent: ()=> import('./components/staff/Profileeditcomponents/my-relationships/my-relationships.component')
            .then(m => m.MyRelationshipsComponent)
          },
          {
            path: 'memberships',
            loadComponent: ()=> import('./components/staff/Profileeditcomponents/my-memberships/my-memberships.component')
            .then(m => m.MyMembershipsComponent)
          },
          {
            path: 'research',
            loadComponent: ()=> import('./components/staff/Profileeditcomponents/my-research/my-research.component')
            .then(m => m.MyResearchComponent)
          },
          {
            path: 'research-guidance',
            loadComponent: ()=> import('./components/staff/Profileeditcomponents/my-research-guidance/my-research-guidance.component')
            .then(m => m.MyResearchGuidanceComponent)
          },
          {
            path: 'research-scholars',
            loadComponent: ()=> import('./components/staff/Profileeditcomponents/my-research-scholars/my-research-scholars.component')
            .then(m => m.MyResearchScholarsComponent)
          },
          {
            path: 'events',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-events/my-events.component')
            .then( m=> m.MyEventsComponent)
          },
          {
            path: 'publications',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-publications/my-publications.component')
            .then(m => m.MyPublicationsComponent)
          },
          {
            path: 'book-publications',
            loadComponent: ()=>import('./components/staff/Profileeditcomponents/my-book-publications/my-book-publications.component')
            .then(m => m.MyBookPublicationsComponent)
          },
          {
            path: 'responsibilities',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-resposibility/my-resposibility.component')
            .then(m => m.MyResposibilityComponent)
          },
          {
            path: 'experience',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-experience/my-experience.component')
            .then(m => m.MyExperienceComponent)
          },
          {
            path: 'mypaperpresentation',
            loadComponent: () => import('./components/staff/Profileeditcomponents/my-paper-presentation/my-paper-presentation.component')
            .then(m => m.MyPaperPresentationComponent)
          }
        ]
       },
       {
        path: 'attendance/posting/check',
        loadComponent: () => import('./components/hoddashboard/attendance-posting-check/attendance-posting-check.component')
        .then(m => m.AttendancePostingCheckComponent),
        data: {title: 'Attendance Check', breadcrumb: 'Attendance Check'}
       },
       {
        path: 'lessthan/65/attendance',
        loadComponent: () => import('./components/principal/lessthan65-attendance/lessthan65-attendance.component')
        .then(m => m.Lessthan65AttendanceComponent),
        data: {title: 'Less than 65% Attendance', breadcrumb: 'Attendance Check'}
       },
       {
        path: 'attendance/posted/report',
        loadComponent: () => import('./components/staff/attendance-posted-report/attendance-posted-report.component')
        .then(m => m.AttendancePostedReportComponent),
        data: {title: 'Attendance Report', breadcrumb: 'Attendance Report'}
       },
       {
        path: 'attendance/cell',
        loadChildren: () => import('./components/dashboards/attendancecell/attendancecell.routes')
        .then(m => m.attendanceCellRoutes)
       }
    ]
  },

  // wildcard
  { path: '**', redirectTo: 'login' }
];
